<template>
  <div class="pages">
    <div class="pageContent">
      <img class="bottom-bg" src="~@/assets/img/home_bottom_bg.jpg" />
      <div class="goBack">
        <img
          src="@/assets/img/goBack_btn_white.svg"
          alt=""
          @click="$router.push('Home')"
          v-if="!showRegister"
        />
      </div>
      <div
        class="notify-box"
        v-if="showRegister && status"
        @click.stop="$router.push('notify')"
      >
        <img class="notify-img" src="@/assets/img/notify.svg" />
        <div class="notify-num" v-show="notifyNum && notifyNum > 0">
          <div class="tiny-font">{{ notifyNum }}</div>
        </div>
      </div>
      <div class="language" v-if="showRegister">
        <span
          class="left"
          :class="{ opacity3: $i18n.locale === 'en' }"
          @click="() => $changeLocale('zh')"
          >中文</span
        >
        <span class="border">/</span>
        <span
          class="right"
          :class="{ opacity3: $i18n.locale === 'zh' }"
          @click="() => $changeLocale('en')"
          >EN</span
        >
      </div>
      <div class="right-btn">
        <img
          src="@/assets/img/setting.svg"
          @click.stop="$router.push('setting')"
          v-if="showRegister"
        />
      </div>
      <div class="character-card">
        <div class="photo-box" :class="{ 'no-img-box': !userInfo.photo }">
          <img
            class="photo"
            :class="{ 'no-img': !userInfo.photo }"
            :src="!userInfo.photo ? noImg : toMedia(userInfo.photo)"
            alt=""
          />
        </div>
        <div class="content">
          <div class="name">{{ $t1(userInfo, "name") }}</div>
          <div class="english-name"></div>
          <!-- <div>人员类型：{{$t3(...typeDict[userInfo.peopleType])}}</div>
          <div v-if="userInfo.type != 'WK'">代表国家：{{$t1(dict.nationality[userInfo.nationality], 'name')}}</div> -->
          <div class="unit-name">
            {{ $t3("单位及职务", "Title") }}：{{
              $t1(userInfo, "company") + $t1(userInfo, "job")
            }}
          </div>
        </div>
        <!-- <img
          class="qr-code"
          v-if="$route.params.type !== 'WK'"
          @click="QRcodeDialog = true"
          src="@/assets/img/QRcode.png"
          alt=""
        /> -->
      </div>
      <!-- <div class="change-infor" v-if="showInforBtn">
        <button class="infor-btn" @click="goEdit">{{$t3('修改报名信息', 'Edit registrational Information')}}</button>
      </div> -->
      <!-- 
      <div class="flow-content" v-if="notEndList && notEndList.length">
        <div class="title">{{$t3('待参加', 'Not started')}}</div>
        <div class="item-card" v-for="(item, index) in notEndList" :key="index">
          <div><div>{{$t1(item, 'title')}}</div><span :class="item.color">{{$t1(item, 'typeName')}}</span></div>
          <div>{{item.date.substring(0, 11).replace(/-/g, '.')}} {{item.startTime + '-' + item.endTime}}</div>
          <div class="address"><img src="@/assets/img/address.png" alt=""/>{{$t1(item, 'placeName')}}</div>
          <div><img src="@/assets/img/seat.png" alt=""/>{{item.seat ? item.seat : $t3('暂无', 'TBD')}}</div>
        </div>
      </div>
      <div class="flow-content" v-if="endList && endList.length">
        <div class="title">{{$t3('已结束', 'Finished')}}</div>
        <div class="item-card opacity" v-for="(item) in endList" :key="item.time">
          <div><div>{{$t1(item, 'title')}}</div><span :class="item.color">{{$t1(item, 'typeName')}}</span></div>
          <div>{{item.date.substring(0, 11).replace(/-/g, '.')}} {{item.startTime + '-' + item.endTime}}</div>
          <div class="address"><img src="@/assets/img/address.png" alt=""/>{{$t1(item, 'placeName')}}</div>
          <div><img src="@/assets/img/seat.png" alt=""/>{{item.seat ? item.seat : $t3('暂无', 'TBD')}}</div>
        </div>
      </div> -->
      <regist-info v-if="showRegister" />
      <div class="personal-information" v-else>
        <van-tabs :swipe-threshold="0" v-model="tabActie" class="personal-tabs">
          <van-tab :title="$t('personal.tab1')"></van-tab>
          <van-tab :title="$t('personal.tab2')"></van-tab>
          <van-tab :title="$t('personal.tab3')"></van-tab>
          <van-tab :title="$t('personal.tab4')"></van-tab>
          <van-tab :title="$t('personal.tab5')"></van-tab>
          <van-tab :title="$t('personal.tab6')"></van-tab>
        </van-tabs>

        <active-info v-show="tabActie == 0" />

        <traffic-info v-show="tabActie == 1" />

        <accommodation-info v-show="tabActie == 2" />

        <dinner-info v-show="tabActie == 3" />

        <contact-info v-show="tabActie == 4" />

        <conference-info v-show="tabActie == 5" />
      </div>

      <!-- 暂无数据 -->
      <!-- <div
        class="no-more no-activity"
        v-show="
          (!notEndList || !notEndList.length) && (!endList || !endList.length)
        "
      >
        <img v-if="$i18n.locale === 'zh'" src="@/assets/img/noActivity.svg" />
        <img v-else src="@/assets/img/noActivityEn.svg" />
      </div> -->
    </div>
    <van-dialog
      v-model="QRcodeDialog"
      class="QRcode-dialog"
      close-on-click-overlay
      confirm-button-text=""
    >
      <!-- <img src="@/assets/img/codeImg.png" alt=""/> -->
      <div id="qrCode" ref="qrCodeDiv"></div>
      <div class="name">{{ $t1(userInfo, "name") }}</div>
      <div class="state">
        <span :class="signColorDict[userInfo.signState]">{{
          $t3(...signDict[userInfo.signState])
        }}</span>
        <span :class="certColorDict[userInfo.certState]">{{
          $t3(...certDict[userInfo.certState])
        }}</span>
      </div>
      <div class="bottom" :class="$i18n.locale">
        {{
          $t3(
            "向工作人员出示用于查看参会信息",
            "The QR Code is for your convenience at the registration desk or conference activity entries."
          )
        }}
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getConferenceInfo } from "@/api/conference";
import { getQrcode } from "@/api/login";
// import { getScheduleNotEnd, getScheduleEnded } from "@/api/schedule";
import { mapGetters } from "vuex";
import { getDictSelArr } from "@/api/dict";
import { toMedia } from "@/utils/request";
import QRCode from "qrcodejs2";
import RegistInfo from "./personal/RegistInfo.vue";
import ActiveInfo from "./personal/ActiveInfo.vue";
import TrafficInfo from "./personal/TrafficInfo.vue";
import AccommodationInfo from "./personal/AccommodationInfo.vue";
import DinnerInfo from "./personal/DinnerInfo.vue";
import ContactInfo from "./personal/ContactInfo.vue";
import ConferenceInfo from "./personal/ConferenceInfo.vue";
import { COMMON } from "@/common";
import { getNotifyNum } from "@/api/notify";
import noImg from "@/assets/img/no_img.png";

export default {
  components: {
    RegistInfo,
    ActiveInfo,
    TrafficInfo,
    AccommodationInfo,
    DinnerInfo,
    ContactInfo,
    ConferenceInfo,
  },
  name: "personalPage",
  data() {
    return {
      showRegister: true,
      signColorDict: {
        0: "purple",
        1: "green",
      },
      signDict: {
        0: ["未签到", "Registration ×"],
        1: ["已签到", "Registration √"],
      },
      certColorDict: {
        0: "orange",
        1: "green",
        2: "green",
      },
      certDict: {
        0: ["未制证", "Conference Pass ×"],
        1: ["已制证", "Conference Pass √"],
        2: ["已领取", "Conference Pass collected"],
      },
      typeDict: {
        GT_D: ["国内嘉宾", "国内嘉宾EN"],
        GT_I: ["国际嘉宾", "国际嘉宾EN"],
        MT: ["媒体记者", "媒体记者EN"],
        WK: ["工作人员", "工作人员EN"],
        GZ: ["广州嘉宾", "广州嘉宾EN"],
      },
      notEndList: [],
      endList: [],
      QRcodeDialog: false,
      nationality: [],
      dict: {
        nationality: {},
      },
      showInforBtn: false,
      qrcode: "",
      tabActie: 0,
      language: false,
      notifyNum: 0,
      typeDict: {
        GT_D: "GN",
        GT_I: "GJ",
        MT: "MT",
        WK: "WK",
        GZ: "GZ",
      },
      noImg: noImg,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "status", "peopleType", "userId"]),
  },
  watch: {
    QRcodeDialog(val) {
      if (val && !this.qrcode) {
        this.getQrcode();
      }
    },
  },
  mounted() {
    this.qrcode = "";
    // if (this.userInfo.type === "GT" && this.userInfo.needUpdateInfo) {
    //   this.$router.push("guestInfo");
    // } else {
    this.getConferenceInfo();
    this.getScheduleInfo();
    this.getDictSelArr();
    // }
    if (this.status) {
      this.getNotifyNum();

      // socket相关
      var that = this;
      var websocket;
      var url =
        COMMON.SOCKET_URL +
        this.typeDict[this.peopleType] +
        (this.userId ? this.userId.replace(/\//g, "___") : "");
      // var url = "wss://platform.cbkjzg.com/api/platform/websocket/" + this.merchantStaffId
      var reconnectTimer = null;

      createWebSocket(url);
      // 重连
      function reconnect(url) {
        if (reconnectTimer) {
          clearTimeout(reconnectTimer);
        }
        reconnectTimer = setTimeout(() => {
          //没连接上会一直重连，设置延迟避免请求过多
          createWebSocket(url);
        }, 5000);
      }
      // 实例websocket
      function createWebSocket(url) {
        try {
          if ("WebSocket" in window) {
            websocket = new WebSocket(url);
          } else if ("MozWebSocket" in window) {
            websocket = new MozWebSocket(url);
          } else {
            websocket = new SockJS(url);
          }
          initEventHandle();
        } catch (e) {
          reconnect(url);
        }
      }

      // 初始化事件函数
      function initEventHandle() {
        websocket.onclose = function () {
          reconnect(url);
        };
        websocket.onerror = function (err) {
          reconnect(url);
        };
        websocket.onopen = function () {
          console.log("socket connect");
        };
        websocket.onmessage = function (res) {
          //如果获取到消息，心跳检测重置
          console.log(res);
          // 如果有新消息了，更新未读消息数量。
          if (res.data === "addNotify") {
            that.getNotifyNum();
          }
        };
      }
    }
  },
  methods: {
    toMedia,
    goEdit() {
      if (this.$route.params.type === "GT") {
        this.$router.push("guestInfo");
      } else if (this.$route.params.type === "MT") {
        this.$router.push("media");
      } else if (this.$route.params.type === "WK") {
        this.$router.push("staff");
      } else if (this.$route.params.type === 'GZ') {
        this.$router.push("guangzhou")
      }
    },
    getConferenceInfo() {
      getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(
        (res) => {
          this.conferenceInfo = res.data;
          this.showInforBtn =
            this.checkTimeBetween(
              res.data.modificationStartTime,
              res.data.modificationEndTime
            ) && this.userInfo.status !== "AUDIT";
        }
      );
    },
    getDictSelArr() {
      getDictSelArr({
        conferenceId: this.$route.params.conferenceId,
        codes: "nationality",
      }).then((res) => {
        if (Object.hasOwnProperty.call(res.data, "nationality")) {
          this.nationality = res.data.nationality.map((x) => x.code);
          this.dict.nationality = {};
          for (const dict of res.data.nationality) {
            this.dict.nationality[dict.code] = {
              name: dict.name,
              nameEn: dict.nameEn,
            };
          }
        }
      });
    },
    getScheduleInfo() {
      // getScheduleNotEnd().then((res) => {
      //   this.notEndList = res.data;
      // });
      // getScheduleEnded().then((res) => {
      //   this.endList = res.data;
      // });
    },
    getQrcode() {
      getQrcode().then((res) => {
        this.qrcode = res.data;
        const div = this.$refs.qrCodeDiv;
        const width = div.offsetWidth;
        const height = div.offsetHeight;
        new QRCode(div, {
          text: res.data,
          width,
          height,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.M, //容错率，L/M/H
        });
      });
    },
    checkTimeBetween(start, end) {
      if (!start || !end) {
        return false;
      }
      const now = new Date();
      const startDate = new Date(start.replace(/-/g, "/"));
      const endDate = new Date(end.replace(/-/g, "/"));
      if (now >= startDate && now <= endDate) {
        return true;
      }
      return false;
    },
    getNotifyNum() {
      getNotifyNum().then((res) => {
        this.notifyNum = res.data;
      });
    },
    langChange(lang) {
      this.$changeLocale(lang);
    },
  },
};
</script>
<style lang="scss" scoped>
.pageContent {
  position: relative;
  height: auto;
  min-height: 100%;
  background: url("./../assets/img/home_bg.jpg") center no-repeat;
  background-size: cover;

  .bottom-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 340px;
    width: 100%;
    object-fit: contain;
    z-index: 0;
  }

  .character-card {
    margin: 15px 0 20px;
    display: flex;
    flex-direction: row;
    padding: 24px 15px 46px;
    background: rgba(255, 255, 255, 0.1) url("./../assets/img/personCard.png")
      center no-repeat;
    background-size: cover;
    backdrop-filter: blur(2px);
    box-sizing: border-box;

    .photo-box {
      border-radius: 4px;
      border: 4px solid rgba(0,0,93,0.08);
      margin-right: 20px;
      height: 120px;
      img.photo {
        width: 90px;
        height: 120px;
        border-radius: 4px;
        object-fit: cover;
      }
      &.no-img-box {
        border: none;
      }
    }

    .qr-code {
      position: absolute;
      top: 33px;
      right: 20px;
      display: block;
      width: 46px;
      height: 46px;
      margin: 0 0 0 10px;
      object-fit: contain;
      background: transparent;
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;

      .name {
        margin: 10px 0 0;
        padding-right: 60px;
        font-size: 19px;
        font-weight: 500;
        color: #ffffff;
        line-height: 26px;
      }

      .english-name {
        margin: 2px 0 0;
        min-height: 16px;
        padding-right: 60px;
        font-size: 13px;
        font-family: Helvetica;
        color: rgba(255, 255, 255, 0.8);
        line-height: 16px;
      }

      .unit-name {
        margin: 20px 0 0;
        font-size: 13px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.7);
        line-height: 18px;
        text-align: left;
      }
    }
  }

  .change-infor {
    width: 100%;
    height: 43px;
    margin: 15px 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    .infor-btn {
      width: 345px;
      height: 43px;
      background: #026de0;
      border-radius: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      border: none;
    }
  }

  .flow-content {
    display: flex;
    flex-direction: column;
    text-align: left;

    &:nth-last-child(1) {
      padding: 0 0 64px;
    }

    .title {
      margin: 20px 0 0;
      font-size: 17px;
      font-weight: 500;
      color: #ffffff;
      line-height: 25px;
    }

    .item-card {
      display: flex;
      flex-direction: column;
      margin: 10px 0 0;
      width: 100%;
      padding: 15px;
      background: #fff;
      box-sizing: border-box;
      box-shadow: 0px 2px 20px 0px rgba(0, 63, 143, 0.06);
      border-radius: 4px;

      &.opacity {
        div {
          opacity: 0.5;
          color: #96989b !important;
        }
      }

      &:nth-child(2) {
        margin: 15px 0 0;
      }

      div:nth-child(1) {
        font-size: 17px;
        font-weight: 500;
        color: #000409;
        line-height: 26px;

        div:first-child {
          display: inline;
          margin-right: 8px;
        }

        span {
          position: relative;
          padding: 1px 4px 0;
          font-size: 11px;
          font-weight: 400;
          line-height: 18px;
          border-radius: 2px;
          vertical-align: 0.5px;
          box-sizing: border-box;
          display: inline-block;

          &.pink {
            color: #fb5353;
            background: rgba(251, 83, 83, 0.04);
            border: 1px solid rgba(251, 83, 83, 0.5);
          }

          &.grey {
            background: rgba(150, 152, 155, 0.04);
            border: 1px solid rgba(150, 152, 155, 0.5);
            color: #96989b;
          }

          &.orange {
            background: rgba(234, 117, 42, 0.04);
            border: 1px solid rgba(234, 117, 42, 0.5);
            color: #ea752a;
          }

          &.green {
            background: rgba(71, 204, 156, 0.04);
            border: 1px solid rgba(71, 204, 156, 0.5);
            color: #47cc9c;
          }

          &.yellow {
            background: rgba(255, 214, 98, 0.04);
            border: 1px solid rgba(255, 214, 98, 0.5);
            color: #ffd662;
          }

          &.color_01 {
            background: rgba(251, 83, 83, 0.04);
            border: 1px solid rgba(251, 83, 83, 0.5);
            color: #fb5353;
          }

          &.color_02 {
            background: rgba(255, 151, 85, 0.04);
            border: 1px solid rgba(255, 151, 85, 0.5);
            color: #ff9755;
          }

          &.color_03 {
            background: rgba(255, 214, 98, 0.04);
            border: 1px solid rgba(255, 214, 98, 0.5);
            color: #ffd662;
          }

          &.color_04 {
            background: rgba(71, 204, 156, 0.04);
            border: 1px solid rgba(71, 204, 156, 0.5);
            color: #47cc9c;
          }

          &.color_05 {
            background: rgba(110, 145, 254, 0.04);
            border: 1px solid rgba(110, 145, 254, 0.5);
            color: #6e91fe;
          }

          &.color_06 {
            background: rgba(122, 108, 255, 0.04);
            border: 1px solid rgba(122, 108, 255, 0.5);
            color: #7a6cff;
          }

          &.color_07 {
            background: rgba(150, 152, 155, 0.04);
            border: 1px solid rgba(150, 152, 155, 0.5);
            color: #96989b;
          }

          &.color_08 {
            background: rgba(217, 59, 231, 0.04);
            border: 1px solid rgba(217, 59, 231, 0.5);
            color: #d93be7;
          }

          &.color_09 {
            background: rgba(0, 63, 143, 0.04);
            border: 1px solid rgba(0, 63, 143, 0.5);
            color: #003f8f;
          }

          &.color_10 {
            background: rgba(59, 202, 231, 0.04);
            border: 1px solid rgba(59, 202, 231, 0.5);
            color: #3bcae7;
          }

          &.color_11 {
            background: rgba(198, 143, 34, 0.04);
            border: 1px solid rgba(198, 143, 34, 0.5);
            color: #c68f22;
          }

          &.color_12 {
            background: rgba(166, 18, 18, 0.04);
            border: 1px solid rgba(166, 18, 18, 0.5);
            color: #a61212;
          }

          &.color_13 {
            background: rgba(34, 145, 73, 0.04);
            border: 1px solid rgba(34, 145, 73, 0.5);
            color: #229149;
          }
        }
      }

      div:nth-child(2) {
        margin: 5px 0 0;
        font-size: 16px;
        color: #383c41;
        line-height: 19px;
      }

      div:nth-child(3),
      div:nth-child(4) {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #96989b;
        line-height: 20px;

        img {
          display: block;
          width: 16px;
          height: 16px;
          margin-right: 4px;
          object-fit: contain;
        }
      }

      div:nth-child(3) {
        margin: 10px 0 0;
      }

      div:nth-child(4) {
        margin: 5px 0 0;
      }
    }
  }

  .no-more {
    margin-top: 26px;
    font-size: 12px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    color: #e6e8ebaa;
    line-height: 20px;

    &.no-activity {
      margin-top: 100px;
    }
  }

  .van-tabs-content {
    margin: 20px 0 0;

    &.item1 {
      .item1-content-box {
        position: relative;
        margin: 0 0 25px;

        .day-style {
          margin: 0 0 2px;
          width: 107px;
          height: 38px;
          padding-left: 10px;
          background: url("~@/assets/img/day_bg.png") no-repeat;
          background-size: contain;
          box-sizing: border-box;
          font-size: 15px;
          font-family: GalanoGrotesqueDEMO-Bold, GalanoGrotesqueDEMO;
          font-weight: bold;
          color: #ffffff;
          line-height: 20px;
          text-align: left;
        }

        .item1-content-card {
          position: relative;
          padding-left: 20px;
          padding-bottom: 15px;

          &:last-child {
            .left-style .line {
              display: none;
            }
          }

          .time-identity {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 0 0 8px;

            .time {
              font-size: 14px;
              font-family: Helvetica;
              color: #ffffff;
              line-height: 17px;
            }

            .identity {
              margin-left: 8px;
              height: 16px;
              border-radius: 2px;
              padding: 0 4px;
              font-size: 10px;
              font-weight: 500;
              color: #ffffff;
              line-height: 18px;
              box-sizing: border-box;

              &.green {
                background: linear-gradient(235deg, #48c33e 0%, #2c8f23 100%);
              }

              &.blue {
                background: linear-gradient(141deg, #0f4ac2 0%, #5d83d8 100%);
              }

              &.orange {
                background: linear-gradient(141deg, #fd584b 0%, #f68a45 100%);
              }

              &.yellow {
                background: linear-gradient(141deg, #e5b57d 0%, #fde5ce 100%);
              }
            }
          }

          .card {
            padding: 15px;
            border-radius: 4px 0px 0px 4px;
            background: linear-gradient(
              270deg,
              rgba(94, 113, 215, 0) 0%,
              #303dae 100%
            );
            border-image: linear-gradient(
                270deg,
                rgba(69, 132, 199, 0),
                rgba(71, 137, 199, 0.4)
              )
              1 1;
            text-align: left;

            .title {
              margin: 0 0 8px;
              font-size: 15px;
              font-weight: 500;
              color: #ffffff;
              line-height: 20px;
            }

            .address,
            .position {
              position: relative;
              padding-left: 21px;
              font-size: 13px;
              font-weight: 400;
              color: rgba($color: #fff, $alpha: 0.6);
              line-height: 19px;
            }

            .address::before,
            .position::before {
              content: "";
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 0;
              width: 16px;
              height: 16px;
            }

            .address::before {
              background: url("~@/assets/img/address_icon.png");
              background-size: contain;
            }

            .position::before {
              background: url("~@/assets/img/position_icon.png");
              background-size: contain;
            }

            .position {
              margin: 5px 0 0;
            }
          }

          .left-style {
            position: absolute;
            left: 0;
            top: 0px;
            bottom: 0;

            .circular {
              position: relative;
              width: 14px;
              height: 14px;
              background: url("~@/assets/img/ic_circular_green.png") center
                no-repeat;
              background-size: contain;
            }

            .line {
              width: 1px;
              margin: 8px auto 0;
              height: calc(100% - 22px);
              background-image: linear-gradient(
                to bottom,
                #3eb134 0%,
                #3eb134 10%,
                transparent 20%
              );
              background-size: 1px 10px;
              background-repeat: y-repeat;
            }
          }
        }
      }
    }

    &.item2 {
      .item2-content-box {
        .day-style {
          margin: 0 0 8px;
          width: 53px;
          height: 21px;
          padding-left: 11px;
          font-size: 12px;
          font-weight: 500;
          color: #fff;
          line-height: 23px;
          text-align: left;
          background: url(~@/assets/img/tag_bg_green.png) no-repeat;
          background-size: contain;
          box-sizing: border-box;
        }

        .item2-content-card {
          margin: 0 0 5px;
          position: relative;
          padding-left: 20px;
          padding-bottom: 15px;

          &:last-child {
            .left-style {
              .line {
                display: none;
              }

              .circular {
                background: url("~@/assets/img/ic_circular_blue.png") center
                  no-repeat;
                background-size: contain;
              }
            }

            .card .time {
              .date {
                width: 117px;
                height: 25px;
                background: url("~@/assets/img/high-speed_img.png");
                background-size: contain;
              }
            }
          }

          .card {
            padding: 20px 20px 0;
            height: 153px;
            width: 326px;
            box-sizing: border-box;
            background: url("~@/assets/img/card_img.png") center no-repeat;
            background-size: 100% 100%;

            .address {
              position: relative;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .from,
              .to {
                font-size: 14px;
                font-weight: 400;
                color: rgba($color: #fff, $alpha: 0.8);
                line-height: 20px;
              }

              .date {
                font-size: 12px;
                font-weight: 400;
                color: rgba($color: #fff, $alpha: 0.8);
                line-height: 20px;
              }
            }

            .time {
              margin: 2px 0 0;
              position: relative;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .from,
              .to {
                font-size: 24px;
                font-weight: bold;
                color: rgba($color: #fff, $alpha: 1);
                line-height: 29px;
              }

              .date {
                width: 117px;
                height: 25px;
                background: url("~@/assets/img/air_img.png");
                background-size: contain;
              }

              .add-num {
                position: absolute;
                right: -14px;
                top: -3px;
                font-size: 12px;
                color: #1debff;
                line-height: 14px;
              }
            }

            .position {
              position: relative;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              .from,
              .to {
                font-size: 12px;
                font-weight: 400;
                color: rgba($color: #fff, $alpha: 0.8);
                line-height: 20px;
              }
            }

            .bottom {
              display: flex;
              flex-direction: row;
              align-items: center;
              height: 44px;
              margin: 20px 0 0;

              img {
                display: block;
                width: 17px;
                height: 17px;
                object-fit: contain;
              }

              .name {
                margin-left: 8px;
                font-size: 13px;
                font-weight: 500;
                color: rgba($color: #fff, $alpha: 0.8);
              }

              .classes {
                margin-left: 4px;
                font-size: 13px;
                font-weight: bold;
                color: rgba($color: #fff, $alpha: 0.8);
              }
            }
          }

          .left-style {
            position: absolute;
            left: 0;
            top: 2px;
            bottom: 0;

            .circular {
              position: relative;
              width: 14px;
              height: 14px;
              background: url("~@/assets/img/ic_circular_green.png") center
                no-repeat;
              background-size: contain;
            }

            .line {
              width: 1px;
              margin: 8px auto 0;
              height: calc(100% - 22px);
              background-image: linear-gradient(
                to bottom,
                #3eb134 0%,
                #3eb134 10%,
                transparent 20%
              );
              background-size: 1px 10px;
              background-repeat: y-repeat;
            }
          }

          &:nth-child(2) {
            .day-style {
              background: url(~@/assets/img/tag_bg_blue.png) no-repeat;
              background-size: contain;
            }
          }
        }
      }
    }
  }

  .personal-register-information {
    position: relative;
    padding: 17px 0 0;

    &::before {
      content: "";
      position: absolute;
      top: 13px;
      left: 50%;
      transform: translateX(-50%);
      width: 135px;
      height: 18px;
      background: url("~@/assets/img/REGISTER_bg.png") center no-repeat;
      background-size: contain;
      z-index: 0;
    }

    .register-title {
      position: relative;
      font-size: 17px;
      font-family: SourceHanSansSC-Bold, SourceHanSansSC;
      font-weight: bold;
      color: #1debff;
      line-height: 25px;
      z-index: 1;
    }

    .infor-box {
      position: relative;
      width: 100%;
      height: 152px;
      margin: 0 0 8px;
      box-sizing: border-box;

      .button {
        position: absolute;
        left: 41px;
        bottom: 27px;
        min-width: 74px;
        padding: 4px 20px;
        box-sizing: border-box;
        background: rgba($color: #3eb134, $alpha: 0.79);
        border-radius: 16px;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 21px;
        letter-spacing: 2px;
      }

      &.basic {
        background: url(~@/assets/img/basic_info_bg.png) no-repeat;
        background-size: contain;
      }

      &.intention {
        background: url(~@/assets/img/intention_info_bg.png) no-repeat;
        background-size: contain;
      }

      &.traffic {
        margin: 0 0 50px;
        background: url(~@/assets/img/traffic_info_bg.png) no-repeat;
        background-size: contain;

        .button {
          background: rgba($color: #5461cc, $alpha: 0.33);
          color: rgba($color: #fff, $alpha: 0.3);
        }
      }
    }
  }
}

.notify-box {
  position: absolute;
  top: 20px;
  left: 15px;

  .notify-num {
    position: absolute;
    left: 16px;
    bottom: 16px;
    height: 14px;
    min-width: 14px;
    background: #fb5353;
    border-radius: 50%;
    font-size: 12px;
    font-family: Helvetica;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    .tiny-font {
      font-size: 12px;
      transform: scale(0.8);
    }
  }
}

.language {
  position: absolute;
  top: 24px;
  right: 16px;
  font-size: 12px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #fff;
  display: flex;

  .left,
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .left {
    margin-right: 4px;
  }
  .right {
    margin-left: 4px;
  }

  .border {
    font-size: 10px;
    color: rgba($color: #fff, $alpha: 0.5);
    font-weight: 400;
  }

  span.opacity3 {
    color: rgba($color: #fff, $alpha: 0.5);
  }
}

.right-btn {
  position: absolute;
  top: 20px;
  right: 15px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  line-height: 17px;

  span {
    opacity: 0.5;
  }

  height: 24px;
}

.language + .right-btn {
  right: 88px;
}
</style>
